import HealthcareDisparity from './HealthcareDisparity';

export default HealthcareDisparity;
